// packages
import { z } from 'zod'
import { UserProps } from './user'
import { privateRouteSchema } from './route'

// enums
export enum message_status {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  PROCESSING = 'PROCESSING'
}

// types
export type MessageProps = {
  id?: number
  ref?: string
  content?: string
  conversationId?: number
  senderId?: number
  paths?: string[]
  spentValue?: number
  runId?: string
  status?: message_status
  isRead?: boolean
  createdAt?: Date
  updatedAt?: Date | null

  // relationships
  sender?: UserProps
}

// schemas
export type CreateMessageSchema = z.infer<typeof createMessageSchema>
export type DeleteMessageSchema = z.infer<typeof deleteMessageSchema>

export const createMessageSchema = privateRouteSchema.extend({
  conversationRef: z.string({ message: 'Informe a conversa.' }).optional(),
  content: z.string({ message: 'Informe a conteúdo.' }).optional(),
  paths: z.array(z.string({ message: 'Informe o caminho.' })).optional()
})

export const deleteMessageSchema = privateRouteSchema.extend({
  ref: z.string({ message: 'Informe a referência.' }).uuid({ message: 'Referência de mensagem inválida.' })
})

export class Message {
  private props: MessageProps

  get id() {
    return this.props.id
  }

  get ref() {
    return this.props.ref
  }

  get content() {
    return this.props.content
  }

  get conversationId() {
    return this.props.conversationId
  }

  get senderId() {
    return this.props.senderId
  }

  get paths() {
    return this.props.paths
  }

  get spentValue() {
    return this.props.spentValue
  }

  get runId() {
    return this.props.runId
  }

  get status() {
    return this.props.status
  }

  get isRead() {
    return this.props.isRead
  }

  get createdAt() {
    return this.props.createdAt
  }

  get updatedAt() {
    return this.props.updatedAt
  }

  get sender() {
    return this.props.sender
  }

  constructor(props: MessageProps) {
    this.props = props
  }
}
